R$ Total<template>

  <div class="pneu-lancamento ml-4 mr-4" >

      <div class="row">
        
    
<!-- VENDAS SINTETICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS SINTETICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS SINTETICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS SINTETICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS SINTETICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS SINTETICA    04/08/2024 AS 13:58H               -->
      <div class="col-12">     
              <b-row class="justify-content-center align-items-center">
                <b-row>
                  <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

                    

                        <b-card                          
                          class="ml-2"
                          style="width: 33rem;"
                          border-variant="primary"
                          header="QUANTIDADE DE TICKET"
                          header-bg-variant="primary"
                          header-text-variant="white"
                          align="center"

                        >
                          <b-card-text> 
                            <h2>                    
                            {{ distinctTicketIdCount }}     
                            </h2>
                          </b-card-text>
                        </b-card>
                      
                      <b-card                  
                        class="ml-2"
                        style="width: 33rem;"              
                        border-variant="primary"
                        header="PARCELAS"
                        header-bg-variant="primary"
                        header-text-variant="white"
                        align="center"
                      >
                        <b-card-text> 
                          <h2>
                            {{ itensFiltradolancamentosParcelas.length }}
                          </h2>               
                          
                        </b-card-text>
                      </b-card>

                      <b-card                  
                      class="ml-2"
                          style="width: 33rem;"
                        
                        border-variant="success"
                        header="VALOR R$"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                      >
                        <b-card-text> 
                          <h2>
                                                        {{ parseFloat(itensFiltradolancamentosParcelas
              .map(v => parseFloat(v.valor_parcela) || 0) // Garantir que cada valor seja um número
              .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0) // Somar os valores
          ).toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
          }) }}

                            
                          </h2>                
                        </b-card-text>
                </b-card>        




                  </b-card-group> 
                </b-row>
              </b-row> 
              
                <b-row cols="12">

                    <b-col cols="2">
                      <div>                            
                          <label  for="datepicker-placeholder">Data Inicio</label>
                          <b-form-datepicker id="datepicker-placeholder2" required v-model="dt_inicio" placeholder="Data inicio" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                      </div>                     
                    </b-col>
                

                    <b-col cols="2">
                      <div>                            
                          <label  for="datepicker-placeholder">Data Fim</label>
                          <b-form-datepicker id="datepicker-placeholder2" required v-model="dt_fim" placeholder="Data fim" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                      </div>                     
                    </b-col>



                    <b-col cols="2">
                      <label class="mt-4"  for="input-busca"></label> 
                        <b-button class="mt-0 ml-3 mb-3" variant="success" block  @click=" loadlancamentosParcelas()">Pesquisar</b-button>
                    </b-col>
                    

                    <b-col cols="2">
                      <label class="mt-4"  for="input-busca"></label> 
                        <b-button class="ml-3 mb-3" variant="warning" block  @click=" gerarPlanilha()">Gerar planilha</b-button>
                    </b-col>

            
                    <b-col cols="4"  class="mt-1 mb-3">
                      <label  for="input-busca">Pesquisa no grid</label> 
                      <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder=" Registro ou ticket"></b-form-input>              
                    </b-col>        

                </b-row>

        <!--  TABLE DE DADOS                               -->
        <div class="col-12">
          <!--tbl de dados -->
          <b-table id="tbldefeitos"  small hover striped sticky-header="660px"  :items="itensFiltradolancamentosParcelas" :fields="vendasSintetico" >    

            <template #cell(total)="data">
              {{ formatCurrency2(data.item.total) }}
            </template>

            
            <template slot="cell(actions)" slot-scope="data"  >
              <b-button @click="editTicketItens(data.item) " v-b-modal.modal-multi-pneu title="Editar ticket"  size="sm" variant="success" class="mr-2">                
                  <i class="fa fa-exclamation-circle"></i>
              </b-button>            
          </template>           
          </b-table>
        </div>
      </div>

<!-- VENDAS ANALITICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS ANALITICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS ANALITICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS ANALITICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS ANALITICA    04/08/2024 AS 13:58H               -->
<!-- VENDAS ANALITICA    04/08/2024 AS 13:58H               -->


    </div>
    
  </div>  

</template>

<script>
import { baseApiUrl, showError  } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import VueTheMask from 'vue-the-mask';
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'
import NumericInput from '../utilitarios/NumericInput';
import * as XLSX from 'xlsx'


export default {

    name: 'ManutencaoRfiLancamento', 
    
    
    computed : { ... mapState (['user'],),
      itensFiltradolancamentosParcelas(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.lancamentosParcelas.filter((item) =>{
          return (
            item.re.indexOf(this.search) >-1  ||
            item.ticket_id.indexOf(this.search) >-1  
          );
        });
        return valores
        },
        valorTotal() {
          return this.materiais.valor_venda ? (this.materiais.valor_venda * this.venda.quantidade + 0.00) : 0.00;
        },
        formattedValue() {
          return this.formatCurrency(this.venda.folha);
        },

            distinctTicketIdCount() {
      return [...new Set(this.itensFiltradolancamentosParcelas.map(item => item.ticket_id))].length;
    },

formattedTotal() {
  // Verifica se ticketitens é um array
  if (!Array.isArray(this.itensFiltradolancamentosParcelas)) {
    console.error('ticketitens não é um array');
    return 0;
  }

  // Calcula o total somando os valores válidos
  const total = this.itensFiltradolancamentosParcelas
    .map(v => {
      const valor = parseFloat(v.valor_total);
      return isNaN(valor) ? 0 : valor; // Substitui valores inválidos por 0
    })
    .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0.00);

  return total; // Retorna o total
}






    } ,


    data: function() {
      
      return {

        ///CF7 - 01/08/2024 as 21:58h
        dt_inicio: '',
        dt_fim:'',
        lancamentosParcelas:[],
        vendas:[],
        venda:{},
        vendasitens:[],
        vendaitem:{},
        formapagtos:[],
        funcionarios:[],
        funcionario:{},
        financeiros:[],
        materiais:[],
        tipopagtos:[],
        nroTicket : 0,
        ticketsintetico:[],
        ticketitens:[],
        //itensFiltradolancamentosParcelas:[],
        parcelas:[],
        //////////////
        pneus:[],               
        pneu:{},
        filiais:[],
        fabricantes:[],
        vidas:[],
        borrachas:[],
        carcacas:[],
        statuss:[],
        pneussaldo:[],
        value_fornecedor:0,
        fornecedores:[],
        





        isLoading: false,
        dt_abertura: '',
            empresas:[],
            filiais:[],

            empresasf:[],
            empresaf:{},
            filialf:{},
            pneus:[],
            operador:[],            
            socorrista_carro:[],
            trocado_carro:[],
            socorristas:[],
            pneus:[],
            pneu:{},
            viacep:[],

            value_empresaf: [],



            defeitos:[],
            defeito:{},

            gruposi:[],
            subgruposi:[],
            defeitosi:[],
            
            gruposd:[],
            subgruposd:[],
            defeitosd:[],

            executante:{},
            executantes: [],  
            lider:{},
            lideres:[],





            mode: 'save',
            carregando: false,
            atualizando: false, 

            
            
            

            
            
            grupo:{},
            grupos:[],
            subgrupo:{},
            subgrupos:[],
            defeito:{},
            defeitos:[],

                        
           // gruposd:[],
            gruposd:{},
            subgrupod:{},
            subgruposd:[],
            defeitod:{},


            solicitante:{},
            solicitantes:[],


            socorrista:{},
            linhas:[],

            nropneu:[],

            pneueditdefeito:[],
            
            

            situacaojb:[],

            value_carro:'',
            value_carro_socorrista:'',
            value_carro_trocado:'',
            value_cep:'',
            value_solicitante:'',
            value_executante:'', 
            value_socorrista:'',           
            value_status:[],
            value_statusjb:[],
            value_tipo:[],
            value_lider:'',
            

            //garagem:{},             
            tipos:[] ,
            search:'',


            

            lin:{},
            
            value_garagem:[],// [] lista                         
            
            
            value_observacoes:'',
           
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            vendasSintetico: [      
              /*
                 
              { key: 'dt_lancamento', label: 'Data lançamento', sortable: true, formatter: (value, key, lancamentosParcelas) => {
                   return moment(lancamentosParcelas.dt_lancamento).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },              
              { key: 'empresa_id', label: 'Empresa', sortable: true },                 
              { key: 'filial_id', label: 'Filial', sortable: true },   
               */
              { key: 're', label: 'Funcionário', sortable: true },                                
              { key: 'funcao', label: 'Função', sortable: true },              
              { key: 'ticket_id', label: 'Nrº ticket', sortable: true },  
              { key: 'parcela', label: 'Nº parcela', sortable: true },  
              { key: 'valor_parcela', label: 'R$ Valor da parcela', sortable: true },     
              { key: 'tipo_pagto', label: 'Tipo de Pagamento', sortable: true },                              
              { key: 'dt_vencimento', label: 'Data Vencimento', sortable: true, formatter: (value, key, lancamentosParcelas) => {
                    return moment(lancamentosParcelas.dt_vencimento).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },              
              { key: 'dt_cadastro', label: 'Data gravação', sortable: true, formatter: (value, key, lancamentosParcelas) => {
                    return moment(lancamentosParcelas.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },              
              { key: 'actions', label: 'Ações' },                
              
            ],


            //////// VENDA PRODUTOS
            vendasItens: [                
                { key: 'id', label: 'Item', sortable: true },                 
                { key: 'codigo_erp', label: 'Código', sortable: true },                                                
                { key: 'descricao', label: 'Descrição', sortable: true },                 
                { key: 'quantidade', label: 'Quantidade', sortable: true },                
                { key: 'valor_total', label: 'Valor unitário', sortable: true },                                
                { key: 'valor_total', label: 'Valor Total', sortable: true },                                                
                //{ key: 'defeito_cancelado', label: 'Cancelado', sortable: true,formatter: value => value ? 'Sim' : 'Não'  },     
                { key: 'actions', label: 'Ações' },                
            ]


        }        
    },

    filters: {
      dataFormatada(dt) {
        return dt.substring(0,4)
      }

    },

    components: {
        Multiselect,LoadingModal,VueTheMask,NumericInput
    },


    methods: {

      
  loadlancamentosParcelas() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,        
        "dt_inicio": `${this.dt_inicio}`,
        "dt_fim": `${this.dt_fim}`,
        "filtro": "resumoperiodo"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/financeiro/lancamentos`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.lancamentosParcelas = res.data;  // Atualiza os dados do pneu
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                lancamentosParcelas = {};                
            }
        })
        .catch(showError);
  },



gerarPlanilha() {
  try {
    // Verifique se lancamentosParcelas está definido e contém dados
    if (!this.lancamentosParcelas || this.lancamentosParcelas.length === 0) {
      console.warn('Nenhum dado disponível em lancamentosParcelas');
      return;
    }

    // Filtra e formata os dados
    const dadosFiltrados = this.lancamentosParcelas.map(({ dt_lancamento, re, nome, cpf,local,qtd_parcelas, valor_parcela, total, dt_desconto }) => ({
      dt_lancamento: moment(dt_lancamento).format('DD/MM/YYYY'),
      re,
      nome,
      cpf,
      local,
      qtd_parcelas,
      valor_parcela: parseFloat(valor_parcela).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      total: parseFloat(total).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      dt_desconto: moment(dt_desconto).format('DD/MM/YYYY')
    }));

    // Verifica os dados filtrados
    console.log('Dados filtrados:', dadosFiltrados);

    // Cria uma nova planilha
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dadosFiltrados);

    // Adiciona a planilha ao workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

    // Salva o workbook como arquivo
    const nomeArquivo = `desconto_folha_periodo_${moment(this.dt_inicio).format('DD-MM-YYYY')}_${moment(this.dt_fim).format('DD-MM-YYYY')}.xlsx`;
    console.log('Salvando o arquivo:', nomeArquivo);
    XLSX.writeFile(workbook, nomeArquivo);

  } catch (error) {
    console.error('Erro ao gerar a planilha:', error);
  }
}


,











































      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },



//////cf7
        formatCurrency2(amount) {
      const number = parseFloat(amount);
      if (isNaN(number)) {
        return 'R$ 0,00'; // Valor padrão se não for um número
      }
      return number.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },


      async loadFuncionario() { 
            let corpo = {                             
            "registro": `${this.venda.re}`,
            "id_empresa": `${this.user.id_empresa}`
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.funcionarios = res.data })    
//              this.loadNovoNroTicket()         
      },  

      async loadProdutos() { 
            let corpo = {                             
            //"empresa_id": `${this.materiais.empresa_id}`,
            "codigo_erp": `${this.venda.codigo_erp}`,
            "filtro": 'CF7'
            };             
          const url = `${baseApiUrl}/sambaiba/cf7/produto`
          axios.post(url,corpo)
              .then(res => { this.materiais = res.data })             
      }, 

      
      loadNovoNroTicket() {
            const url = `${baseApiUrl}/sambaiba/cf7/nroticket`
            axios.post(url).then(res => {
              this.nroTicket = res.data.rows[0].nextval
            })
      },

       ///Tipo de pagamento
        loadTipoPagto() {   
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                                           
          };          
          const url = `${baseApiUrl}/sambaiba/cf7/tipopagto`
          axios.get(url)
               .then(res => {this.tipopagtos = res.data.map(sb => {return { ... sb, value: sb.id, tipo: sb.tipo} })})
               .catch(showError)
        },

        loadParcelas() {   
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                                           
          };          
          const url = `${baseApiUrl}/sambaiba/cf7/parcelas`
          axios.get(url)
               .then(res => {this.parcelas = res.data.map(sb => {return { ... sb, value: sb.id, tipo: sb.parcela} })})
               .catch(showError)
        },

  formatCurrency(value) {
    if (!value) return '';
    value = value.toString().replace(/\D/g, ''); // Remove non-digit characters

    // Ensure at least '0'
    value = value.length ? value : '0';

    if (value.length === 1) return `0,0${value}`;
    if (value.length === 2) return `0,${value}`;
    
    const integerPart = value.slice(0, -2);
    const decimalPart = value.slice(-2);
    return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decimalPart;
  },
  convertToDatabaseFormat(value) {
    if (!value) return '0.00';

    // Remove thousand separators (points) and replace the decimal separator (comma) with a dot
    let numericValue = value.toString().replace(/\./g, ''); // Remove all points

    // Find the position of the last comma (if any) and replace it with a dot
    const commaIndex = numericValue.lastIndexOf(',');
    if (commaIndex > -1) {
      numericValue = numericValue.slice(0, commaIndex) + '.' + numericValue.slice(commaIndex + 1);
    } else {
      numericValue += '.00'; // If no comma, add '.00'
    }

    // Ensure at least a zero
    return numericValue || '0.00';
  },




        async postTicketCabecalho() {   
              const formattedCredit = this.convertToDatabaseFormat(this.venda.credito);
            let corpo = {                           
              "id_funcionario": `${this.user.id_funcionario_erp}`,            
              "id": this.nroTicket ? this.nroTicket : this.venda.ticket_id,
              "empresa_id": `${this.funcionarios.id_empresa}`,            
              "filial_id": `${this.funcionarios.id_filial}`,  
              "funcionario_id": `${this.funcionarios.id_funcionario_erp}`,           
              "funcao_id": `${this.funcionarios.id_funcao}`,
              "pix": `${this.venda.pix / 100}`,
              "dinheiro": `${this.venda.dinheiro}`,
              "credito": formattedCredit / 100,
              "debito": `${this.venda.debito / 100}`,
              "vale": `${this.venda.vale / 100}`,    
              "desconto": `${this.venda.desconto / 100}`,    
              "total":  `${this.formattedTotal}`,  
              "tipopagto_id": `${this.venda.tipopagto_id}`,
              "filtro": 'gravar'
                            /*
              "status_id": this.venda.status_id ? `${this.venda.status_id}` : false,
              */
            }; 
          const url = `${baseApiUrl}/sambaiba/cf7/ticketcabecalho`
         axios.post(url,corpo).then(() => {
          this.$toasted.global.defaultSuccess()          
          //this.reset()
           })
           .catch(showError)
      },

          async postTicketItens() {   
              
            let corpo = {                           
              "id_funcionario": `${this.user.id_funcionario_erp}`,            
              "ticket_id":  this.nroTicket ? this.nroTicket : this.venda.ticket_id,
              "id":  this.venda.id ? this.venda.id : null,
              "empresa_id": `${this.funcionarios.id_empresa}`,            
              "filial_id": `${this.funcionarios.id_filial}`,  
              "funcionario_id": `${this.funcionarios.id_funcionario_erp}`,           
              "produto_id": `${this.materiais.id  }`,
              "quantidade": `${this.venda.quantidade}`,
              "tamanho_id": `${this.materiais.tamanho_id}`,
              "cor_id": `${this.materiais.cor_id}`,
              "valor_unitario": `${ parseFloat(this.materiais.valor_venda)}`,                            
              //"desconto": `${this.parseFloat(this.venda.desconto)}`,    
              "valor_total": `${ parseFloat(this.materiais.valor_venda) * parseInt(this.venda.quantidade) }`,    
              "status_id": true,           // true-ativo  / false-cancelado
              "observacao": `${this.venda.observacao}`,
              "filtro": 'gravar'
                         
            }; 
          const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`
         axios.post(url,corpo).then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadTicketSintetico()
          this.loaditensFiltradolancamentosParcelas()
          this.loadTicketItens()
          //this.reset()
           })
           .catch(showError)
      },


      async postFinanceiroParcelas() {                 
            let corpo = {                           
              "id_funcionario": `${this.user.id_funcionario_erp}`,            
              "ticket_id": this.nroTicket ? this.nroTicket : this.venda.ticket_id,
              "empresa_id": `${this.funcionarios.id_empresa}`,            
              "filial_id": `${this.funcionarios.id_filial}`,  
              "funcionario_id": `${this.funcionarios.id_funcionario_erp}`,           
              //"dt_emissao": `${this.funcionarios.id_funcao}`,
              //"dt_vencimento": `${this.funcionarios.id_funcao}`,              
              "parcela_id": `${this.venda.parcela_id}`,
              "tipopagto_id": `${this.venda.tipopagto_id}`,              
              "total":  `${this.formattedTotal}`,                                 
              "filtro": 'gravarparcelas'
            }; 
          const url = `${baseApiUrl}/sambaiba/cf7/financeiro`
         axios.post(url,corpo).then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadTicketSintetico()
          //this.postTicketItens()          
          //this.reset()
           })
           .catch(showError)
      },




  loadTicketSintetico() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,        
        "filtro": "lancamentodia"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/ticketcabecalho`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.ticketsintetico = res.data;  // Atualiza os dados do pneu                
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                ticketsintetico = {};                
            }
        })
        .catch(showError);
  },


    loaditensFiltradolancamentosParcelas() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,                
        "filtro": "lancamentodiacard"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/financeiro/lancamentos`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.lancamentosParcelas = res.data;  // Atualiza os dados do pneu
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                lancamentosParcelas = {};                
            }
        })
        .catch(showError);
  },






      limparFiltro(){
        this.search= ""
      },

        
      loadEmpresa() {
                    let corpo = {    
                        "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
                    };
        
                  const url = `${baseApiUrl}/ctr/empresa`
                  axios.post(url,corpo)
                  .then(res => {this.empresas = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
                  .catch(showError)
      },
      
      loadFilial() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo)
          .then(res => {this.filiais = res.data.map(emp => {return { ... emp, value: emp.id_filial_erp, filial: emp.filial, empresa_id: emp.empresa_id } })})
          .catch(showError)
          
      },

              ///CHASSI FABRICANTE
      loadFabricante() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/fabricante`
          axios.post(url,corpo)
               .then(res => {this.fabricantes = res.data.map(gru => {return { ... gru, value: gru.id, fabricante: gru.fabricante} })})
               .catch(showError)          
        }, 

       
        loadVida() {             
          const url = `${baseApiUrl}/pneu/vida`
          axios.get(url)
               .then(res => {this.vidas = res.data.map(sb => {return { ... sb, value: sb.id, vida: sb.vida} })})
               .catch(showError)
        },





              
      loadBorracha() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/borracha`
          axios.post(url,corpo)
               .then(res => {this.borrachas = res.data.map(gru => {return { ... gru, value: gru.id, borracha: gru.borracha} })})
               .catch(showError)          
        }, 


              
      loadCarcaca() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/desenho`
          axios.post(url,corpo)
               .then(res => {this.carcacas = res.data.map(gru => {return { ... gru, value: gru.id, desenho: gru.desenho} })})
               .catch(showError)          
        }, 


              
      loadStattus() {        
          const url = `${baseApiUrl}/pneu/status`
          axios.get(url)
               .then(res => {this.statuss = res.data.map(gru => {return { ... gru, value: gru.id, status: gru.status} })})
               .catch(showError)          
        }, 

              ///////////////////////////////// 31/12/2022 as 20:17h
      editTicketResumo(venda){
            this.venda = { ...venda }            
            //this.loadTicketItens()
            this.loadFuncionario()
            //this.loadProdutos()            
      },

      
      ///////////////////////////////// 31/12/2022 as 20:17h
      editTicketItens(venda){
            this.venda = { ...venda }            
            this.loadTicketItens()
            this.loadFuncionario()
            this.loadProdutos()            
      },

      
      loadPneuSaldo() {         
          let corpo = {    
               "empresa_id": `${[this.pneu.empresa_id]}`,                                           
               "filial_id": `${[this.pneu.filial_id]}`,
               "origem" : "websaldo"           
          };
          const url = `${baseApiUrl}/pneu/pneu`
          axios.post(url,corpo).then(res => { 
            this.pneussaldo = res.data  
            }            
          )
          .catch(showError)         
      },
      
     
      reset() {
          this.pneu.id  = '';
           this.pneu.fabricante_id  = '';
           this.pneu.medida_id  = '';
           this.pneu.vida_id  = '';
           this.pneu.borracha_id  = '';
           this.pneu.carcaca_id  = '';
           this.pneu.status_id  = '';
           this.pneu.dotserie  = '';
           this.pneu.observacoes = '';

      },

      limparCorpo(){
        this.defeito =[]        
        this.executante=[]
       this.lider=[]        
       this.value_executante=''
        this.value_lider=''
        ///this.nropneu=[]  // precisa limpar somente ao fechar ou quando cria-se uma nova ficha
      },

      novo(){
        this.pneu = {}
        this.defeito = {}                
        this.pneueditdefeito = {}     
      },

            loadPneuFornecedores() {
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,
            "origem": 'listagem'
          };
      const url = `${baseApiUrl}/fin/clifor`;
      axios.post(url, corpo)      
            .then(res => {this.fornecedores = res.data.map(gru => {return { ... gru, value: gru.id, nome: gru.nome} })})  
            .catch(showError)          
      },

       
    },
    
    mounted() {         
      //this.loaditensFiltradolancamentosParcelas()


    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#placa{
    font-size: 0.7em;      
}


#cardvalorticket{
    font-size: 1.3em;      
}


#modal-multi-pneu___BV_modal_content_{
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;  
}


#defeito-selecao{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;  
}

#id-sos{  
  background: rgb(199, 222, 218);
  border: 1px solid red ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-diagnosticado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#id-encerramento{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#pneu-nro{
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
  
}



#garagem{  
  font-size: 12px;
  text-align: center;
  
}



/* Define a altura e a largura da imagem */
.img-custom {
  width: 150px; /* Ajuste conforme necessário */
  height: 150px; /* Ajuste conforme necessário */
  object-fit: cover; /* Garante que a imagem cubra a área sem distorcer */
}


.alert-container {
  position: fixed; /* Fixa o elemento na tela */
  top: 50%; /* Move o elemento para o meio verticalmente */
  left: 50%; /* Move o elemento para o meio horizontalmente */
  transform: translate(-50%, -50%); /* Ajusta a posição para o centro do elemento */
  z-index: 1000; /* Garante que o alerta ficará sobre outros conteúdos */
}

#divisao {
      border: 0;
      height: 4px;
      background: #1405ee; /* Cor da linha */
      margin: 20px 0; /* Espaço acima e abaixo da linha */
    }


</style>